var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2, _path19, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameDarkmode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 896,
    viewBox: "0 0 414 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 30H121V0H81C83.8116 0 86.0909 2.50719 86.0909 5.6V11.3333C86.0909 21.6426 93.6885 30 103.061 30Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    width: 172,
    height: 30,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.939 30H293V0H333C330.188 0 327.909 2.50719 327.909 5.6V11.3333C327.909 21.6426 320.311 30 310.939 30Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M374 0H414V40C414 17.9086 396.091 0 374 0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40C0 17.9086 17.9086 0 40 0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M374 896H414V856C414 878.091 396.091 896 374 896Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 896H0V856C0 878.091 17.9086 896 40 896Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343 20H344C344.552 20 345 20.4477 345 21V27C345 27.5523 344.552 28 344 28H343C342.448 28 342 27.5523 342 27V21C342 20.4477 342.448 20 343 20Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.5 22H339.5C340.052 22 340.5 22.4477 340.5 23V27C340.5 27.5523 340.052 28 339.5 28H338.5C337.948 28 337.5 27.5523 337.5 27V23C337.5 22.4477 337.948 22 338.5 22Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334 23.5H335C335.552 23.5 336 23.9477 336 24.5V27C336 27.5523 335.552 28 335 28H334C333.448 28 333 27.5523 333 27V24.5C333 23.9477 333.448 23.5 334 23.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.5 18H348.5C349.052 18 349.5 18.4477 349.5 19V27C349.5 27.5523 349.052 28 348.5 28H347.5C346.948 28 346.5 27.5523 346.5 27V19C346.5 18.4477 346.948 18 347.5 18Z",
    fill: "white",
    fillOpacity: 0.18
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343 20H344C344.552 20 345 20.4477 345 21V27C345 27.5523 344.552 28 344 28H343C342.448 28 342 27.5523 342 27V21C342 20.4477 342.448 20 343 20Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.5 22H339.5C340.052 22 340.5 22.4477 340.5 23V27C340.5 27.5523 340.052 28 339.5 28H338.5C337.948 28 337.5 27.5523 337.5 27V23C337.5 22.4477 337.948 22 338.5 22Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334 23.5H335C335.552 23.5 336 23.9477 336 24.5V27C336 27.5523 335.552 28 335 28H334C333.448 28 333 27.5523 333 27V24.5C333 23.9477 333.448 23.5 334 23.5Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M363.133 24.9395C363.772 24.9395 364.394 25.1075 364.941 25.4279L365.163 25.5577C365.331 25.6562 365.361 25.8865 365.223 26.024L363.329 27.9129C363.212 28.0289 363.024 28.0289 362.907 27.9129L361.026 26.0362C360.888 25.8993 360.917 25.6701 361.084 25.5709L361.303 25.4405C361.855 25.112 362.485 24.9395 363.133 24.9395Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M363.133 21.4697C364.724 21.4697 366.251 21.9975 367.495 22.9748L367.671 23.1129C367.811 23.223 367.824 23.4305 367.697 23.5564L366.567 24.684C366.462 24.7883 366.297 24.8003 366.178 24.7121L366.04 24.6097C365.2 23.9851 364.186 23.6501 363.133 23.6501C362.073 23.6501 361.053 23.9893 360.21 24.621L360.072 24.7244C359.953 24.8133 359.787 24.8016 359.682 24.697L358.552 23.5697C358.426 23.4442 358.438 23.2372 358.578 23.1269L358.753 22.9886C360 22.0026 361.534 21.4697 363.133 21.4697Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M363.133 18C365.657 18 368.072 18.8906 369.983 20.5229L370.146 20.6623C370.278 20.7749 370.285 20.9756 370.163 21.098L369.036 22.2219C368.926 22.3308 368.752 22.3385 368.634 22.2395L368.494 22.1228C366.989 20.8647 365.104 20.1804 363.133 20.1804C361.155 20.1804 359.263 20.8694 357.756 22.1354L357.617 22.2527C357.498 22.3521 357.324 22.3447 357.214 22.2356L356.087 21.1118C355.965 20.9895 355.972 20.7892 356.104 20.6765L356.266 20.5371C358.18 18.8959 360.601 18 363.133 18Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399 21C399.552 21 400 21.4477 400 22V24C400 24.5523 399.552 25 399 25V21Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378 17H395C396.657 17 398 18.3431 398 20V26C398 27.6569 396.657 29 395 29H378C376.343 29 375 27.6569 375 26V20C375 18.3431 376.343 17 378 17ZM378 18C376.895 18 376 18.8954 376 20V26C376 27.1046 376.895 28 378 28H395C396.105 28 397 27.1046 397 26V20C397 18.8954 396.105 18 395 18H378Z",
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 377,
    y: 19,
    width: 19,
    height: 8,
    rx: 1,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6775 28H37.5305V17.4312H35.6628L32.9016 19.3721V21.1079L35.6335 19.2329H35.6775V28ZM42.7498 28H44.6029V17.4312H42.7352L39.9739 19.3721V21.1079L42.7059 19.2329H42.7498V28ZM48.3939 21.0273C48.9799 21.0273 49.4413 20.5586 49.4413 19.9727C49.4413 19.3867 48.9799 18.918 48.3939 18.918C47.8007 18.918 47.3393 19.3867 47.3393 19.9727C47.3393 20.5586 47.8007 21.0273 48.3939 21.0273ZM48.3939 26.5059C48.9799 26.5059 49.4413 26.0371 49.4413 25.4512C49.4413 24.8652 48.9799 24.3965 48.3939 24.3965C47.8007 24.3965 47.3393 24.8652 47.3393 25.4512C47.3393 26.0371 47.8007 26.5059 48.3939 26.5059ZM53.9355 28H55.7885V17.4312H53.9209L51.1596 19.3721V21.1079L53.8916 19.2329H53.9355V28ZM61.0079 28H62.8609V17.4312H60.9932L58.232 19.3721V21.1079L60.9639 19.2329H61.0079V28Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 883,
    width: 134,
    height: 5,
    rx: 2.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameDarkmode);
export default __webpack_public_path__ + "static/media/frame-darkmode.e36d563b60bf0af1c20dbce98f28931b.svg";
export { ForwardRef as ReactComponent };